'use client';

import { useEffect, useState } from 'react';
import { SuperTokensWrapper } from 'supertokens-auth-react';
import { ensureSuperTokensFrontendInit } from '@/lib/auth/supertokens-client';

export function SuperTokensProvider({ children }: { children: React.ReactNode }) {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    ensureSuperTokensFrontendInit();
    setInitialized(true);
  }, []);

  if (!initialized) {
    return null;
  }

  return <SuperTokensWrapper>{children}</SuperTokensWrapper>;
}
